import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { articles } from '@/mocks/articles';

const relatedArticles = [
  { id: 'litbuy-spreadsheet-templates', title: 'Best LitBuy Spreadsheet Templates in 2026' },
  { id: 'litbuy-spreadsheet-features', title: 'LitBuy Spreadsheet Features Explained' },
  { id: 'how-to-use-litbuy-spreadsheet', title: 'How to Use a LitBuy Spreadsheet Effectively' },
];

export default function BuildPage() {
  return (
    <main>
      <Navbar />
      <ArticleLayout article={articles['build-litbuy-spreadsheet']} relatedArticles={relatedArticles} />
      <Footer />
    </main>
  );
}